import React from 'react';
import DescriptionIcon from '@mui/icons-material/Description';
import MovieIcon from '@mui/icons-material/Movie';
import PhotoIcon from '@mui/icons-material/Photo';
import { AllowedFileTypes } from '@askporter/utils';
export const fileIconMapping: Record<string, JSX.Element> = {
  [AllowedFileTypes.JPG]: <PhotoIcon />,
  [AllowedFileTypes.JPEG]: <PhotoIcon />,
  [AllowedFileTypes.PNG]: <PhotoIcon />,
  [AllowedFileTypes.DOC]: <DescriptionIcon />,
  [AllowedFileTypes.DOCX]: <DescriptionIcon />,
  [AllowedFileTypes.PDF]: <DescriptionIcon />,
  [AllowedFileTypes.MP4]: <MovieIcon />,
  [AllowedFileTypes.HEIC]: <MovieIcon />,
  [AllowedFileTypes.HEIF]: <MovieIcon />,
};
